import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import mainDataReducer from './reducers/reducer-main';
import userReducer from './reducers/reducer-user';
import userSubscribedBiasReducer from "./reducers/reducer-subscribed-bias";
import updateUserSubscribedBiasReducer from "./reducers/reducer-update-subscribed-bias";

export const store = configureStore({
  reducer: {
    mainData: mainDataReducer, 
    userData: userReducer,
    userSubscribedBiasData: userSubscribedBiasReducer,
    updateUserSubscribedBiasData: updateUserSubscribedBiasReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
